import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

const MainContentFixedHeader = memo(({ children, className }) => {
  const classes = classNames({
    'pro-wrapper-main-content-fixed-header': true,
    [className]: !!className,
  });

  return <div className={classes}>{children}</div>;
});

MainContentFixedHeader.propTypes = propTypes;
MainContentFixedHeader.displayName = 'MainContentFixedHeader';

export default MainContentFixedHeader;
